import { Link } from "react-router-dom";
import { FaStar, FaMapMarkerAlt } from "react-icons/fa";

const Banner = () => {
  return (
    <div className="hero-header bg-center bg-cover pt-40 pb-20 lg:py-28 px-6 sm:px-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="lg:w-[60%] text-center lg:text-left mb-12 lg:mb-0">
            <span className="inline-block bg-primary/15 text-primary-light font-semibold text-xs uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
              Since 2017 · Authentic Rajasthani &amp; Punjabi Cuisine
            </span>
            <h1 className="font-display text-white max-w-fit sm:w-full text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Feel Like A <br /> Rajasthani Restaurant
            </h1>
            <p className="text-gray-300 mb-8 text-lg max-w-lg mx-auto lg:mx-0">
              Delicious variety of cuisines, served with warmth and
              tradition.
            </p>
            <div className="flex flex-wrap gap-4 justify-center lg:justify-start mb-8">
              <Link to="/contact-us">
                <button className="bg-primary hover:bg-primary-dark text-ink font-semibold py-3 px-6 rounded-full transition-colors duration-300 transform hover:scale-105">
                  BOOK A TABLE
                </button>
              </Link>
              <Link to="/menu">
                <button className="border border-white/30 hover:border-primary text-white font-semibold py-3 px-6 rounded-full transition-colors duration-300">
                  VIEW MENU
                </button>
              </Link>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-6 gap-y-2 text-gray-300 text-sm">
              <span className="flex items-center gap-1">
                <FaStar className="text-primary" />
                <FaStar className="text-primary" />
                <FaStar className="text-primary" />
                <FaStar className="text-primary" />
                <FaStar className="text-primary" />
                <span className="ml-1">Loved by our guests</span>
              </span>
              <span className="flex items-center gap-1">
                <FaMapMarkerAlt className="text-primary" />
                2 Locations · Mandsaur &amp; Neemuch
              </span>
            </div>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <div
              className="w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden shadow-2xl ring-4 ring-primary/40 animate-spin-slow"
              style={{ animationDuration: "50s" }}
            >
              <img
                src="https://secondhomemds.com/wp-content/uploads/2024/11/WhatsApp-Image-2024-11-23-at-3.12.14-PM-3-1469x1536.jpeg"
                alt="Rajasthani thali"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
